module.exports = __webpack_public_path__ + "static/media/riccioli.bb393c12.jpeg";